import { useState,useEffect,useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { message } from 'antd'
import { LoadingOutlined } from '@ant-design/icons';
import { Login,loginState } from '@/services/login';
import { ResDataType,post } from "@/services/ajax";
import MerchantList from "./components/merchantList";
import type { FormProps } from 'antd';
import { Button, Checkbox, Form, Input } from 'antd';
import './index.css'
import { useDispatch } from 'react-redux';
import { menuPermissions } from '@/constant';
import { setUser } from '@/store/userReducer';

export default function LoginPage() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const dialog = useRef<any>(null);
  const [form] = Form.useForm();

  type FieldType = {
    userNameOrMobile?: string;
    password?: string;
  };
  
  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

   // 获取当前角色权限
const getMenuPermission = (role: keyof typeof menuPermissions) => {
    return menuPermissions[role] || []; 
};

  const onFinish = async () => {
    setLoading(true)
    const values = await form.validateFields();
    const res = await Login(values) as ResDataType;
    if (res.code == 0) {
      localStorage.setItem('token', res.data.accessToken)
      const status = await loginState() as ResDataType;
      if (status.code == 0) {
        localStorage.setItem('merchantId', status.data.merchantId)
       const permissions = getMenuPermission(status.data.role);
      //  console.log('User Permissions:', permissions);
       const isExistMerchantId = status.data.merchantId;
       dispatch(setUser({ userName:status.data.userName,
        mobile:status.data.mobile,role:status.data.role,
        merchantId:status.data.merchantId,merchantName:status.data.merchantName, menu: permissions }))
       if (isExistMerchantId) {
        message.success('登录成功')
        navigate('/main'); 
       } else {
        // 弹窗
        dialog.current?.open();
       }
      }
      
    } else {
      message.error(res.message) 
    }
    setLoading(false)
  }
  return (
    <div className="loginContanier">
      <div className="loginBox">
        <h1 className="loginTitle">1+N 权益管理系统</h1>
      
      <Form
        form={form}
        name="basic"
        size="large"
        layout="vertical"
        labelCol={{ span: 10 }}
        wrapperCol={{ span:19 }}
        style={{ maxWidth: 1000 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item<FieldType>
          label="用户名"
          name="userNameOrMobile"
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input style={{ width:'350px' }} />
        </Form.Item>

        <Form.Item<FieldType>
          label="密码"
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password  style={{ width:'350px' }}/>
        </Form.Item>

        <div style={{ textAlign:'center'}}>
          <Button type="primary" htmlType="submit" style={{ width:'350px',marginInlineStart:'0' }}>
            {loading? <LoadingOutlined /> : ''}
            登录
          </Button>
        </div>
      </Form>
      </div>
      <MerchantList ref={dialog} />
    </div>
  );
} 